// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Rede_EncerramentoConcluirInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /rede/encerramento/concluir — conclui e leva a unidade a encerrada ou repassada (Full). */
import { registerContract } from './validate'

export interface Rede_EncerramentoConcluirInput {
id?: number
destino?: string
desde?: string
novo_franqueado?: string
}

registerContract('Rede_EncerramentoConcluirInput', {
  id:              { type: 'number',  required: false },
  destino:         { type: 'string',  required: false },
  desde:           { type: 'string',  required: false },
  novo_franqueado: { type: 'string',  required: false },
})
